const DEFAULT_TYPO_MAP = {
  dont: "do not",
  doesnt: "does not",
  cant: "cannot",
  wont: "will not",
  scheduole: "schedule",
  tommorow: "tomorrow",
  coah: "coach",
};

function normalizeUnderstandingText(value = "", options = {}) {
  const typoMap = { ...DEFAULT_TYPO_MAP, ...(options.typoMap || {}) };
  return String(value || "")
    .replace(/[’‘]/g, "'")
    .toLowerCase()
    .replace(/\bdon't\b/g, "do not")
    .replace(/\bdoesn't\b/g, "does not")
    .replace(/\bcan't\b/g, "cannot")
    .replace(/\bwon't\b/g, "will not")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((token) => typoMap[token] || token)
    .join(" ");
}

function tokenizeUnderstandingText(value = "", options = {}) {
  const normalized = normalizeUnderstandingText(value, options);
  return normalized ? normalized.split(" ") : [];
}

function editDistanceAtMost(value = "", target = "", maxEdits = 1) {
  const a = String(value || "");
  const b = String(target || "");
  if (a === b) return true;
  if (Math.abs(a.length - b.length) > maxEdits) return false;

  const dp = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));
  for (let i = 0; i <= a.length; i += 1) dp[i][0] = i;
  for (let j = 0; j <= b.length; j += 1) dp[0][j] = j;

  for (let i = 1; i <= a.length; i += 1) {
    let rowMin = Number.MAX_SAFE_INTEGER;
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1,
        dp[i][j - 1] + 1,
        dp[i - 1][j - 1] + cost
      );
      rowMin = Math.min(rowMin, dp[i][j]);
    }
    if (rowMin > maxEdits) return false;
  }

  return dp[a.length][b.length] <= maxEdits;
}

function tokenMatchesTemplate(actual = "", expected = "", options = {}) {
  if (actual === expected) return true;
  if (options.fuzzyTokens?.has?.(expected)) {
    return editDistanceAtMost(actual, expected, options.maxEdits || 1);
  }
  if (options.aliases?.[expected]?.includes?.(actual)) return true;
  return false;
}

function findTokenPhrase(tokens = [], phrase = [], options = {}) {
  if (!phrase.length || tokens.length < phrase.length) return null;
  for (let start = 0; start <= tokens.length - phrase.length; start += 1) {
    let matched = true;
    for (let offset = 0; offset < phrase.length; offset += 1) {
      if (!tokenMatchesTemplate(tokens[start + offset], phrase[offset], options)) {
        matched = false;
        break;
      }
    }
    if (matched) return { start, end: start + phrase.length };
  }
  return null;
}

function hasTokenPhrase(tokens = [], phrase = [], options = {}) {
  return Boolean(findTokenPhrase(tokens, phrase, options));
}

module.exports = {
  editDistanceAtMost,
  findTokenPhrase,
  hasTokenPhrase,
  normalizeUnderstandingText,
  tokenizeUnderstandingText,
};
